import React, { useEffect, useRef, useState } from 'react';
import { AnimatePresence, motion } from 'motion/react';
import {
  fadeUpVariants,
  pageVariants,
  reducedVariants,
  swapVariants,
  tabSwapVariants,
} from './tokens';
import usePrefersReducedMotion from './usePrefersReducedMotion';

export function PageEnter({ children, className = '' }) {
  const reduced = usePrefersReducedMotion();
  const variants = reducedVariants(pageVariants, reduced);

  return (
    <motion.div
      className={className}
      variants={variants}
      initial="hidden"
      animate="visible"
    >
      {children}
    </motion.div>
  );
}

export function FadeIn({ children, className = '', as: Component = 'div' }) {
  const reduced = usePrefersReducedMotion();
  const variants = reducedVariants(fadeUpVariants, reduced);
  const MotionTag = motion[Component] || motion.div;

  return (
    <MotionTag className={className} variants={variants}>
      {children}
    </MotionTag>
  );
}

export function PresenceSwap({
  swapKey,
  children,
  className = '',
  mode = 'wait',
  order,
}) {
  const reduced = usePrefersReducedMotion();
  const prevIndexRef = useRef(null);
  const [direction, setDirection] = useState(1);

  useEffect(() => {
    if (!Array.isArray(order) || order.length === 0) return;
    const nextIndex = order.indexOf(swapKey);
    if (nextIndex < 0) return;
    const prevIndex = prevIndexRef.current;
    if (prevIndex != null && prevIndex !== nextIndex) {
      setDirection(nextIndex > prevIndex ? 1 : -1);
    }
    prevIndexRef.current = nextIndex;
  }, [swapKey, order]);

  const base = Array.isArray(order)
    ? tabSwapVariants(direction)
    : swapVariants;
  const variants = reducedVariants(base, reduced);

  return (
    <AnimatePresence mode={mode} initial={false} custom={direction}>
      <motion.div
        key={swapKey}
        className={className}
        variants={variants}
        initial="hidden"
        animate="visible"
        exit="exit"
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
}

export function PageTransition({ children, className = '' }) {
  return <div className={className}>{children}</div>;
}
